import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appFloatFormat]',
})
export class FloatFormatDirective {
  @Input()
  precision: number = 0;
  private lastValidValue: string = '';
  private isComposing: boolean = false;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['precision']) {
      this.formatValue(this.el.nativeElement.value);
    }
  }

  @HostListener('compositionstart')
  onCompositionStart() {
    this.isComposing = true;
  }

  @HostListener('compositionend', ['$event.target.value'])
  onCompositionEnd(value: string) {
    this.isComposing = false;
    this.validateInput(value);
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    if (this.isComposing) return;
    this.validateInput(value);
  }

  private validateInput(value: string): void {
    // 允许空值、单独负号、单独小数点、负号加点开头
    if (value === '' || value === '-' || value === '.' || value === '-.') {
      this.lastValidValue = value;
      return;
    }

    // 检查合法格式
    if (!/^-?\d*\.?\d*$/.test(value)) {
      this.revertValue();
      return;
    }

    // 检查精度要求
    if (this.precision === 0 && value.includes('.')) {
      this.revertValue();
      return;
    }

    // 检查小数位数
    const decimalIndex = value.indexOf('.');
    if (decimalIndex !== -1) {
      const decimalPart = value.substring(decimalIndex + 1);
      if (decimalPart.length > this.precision) {
        this.revertValue();
        return;
      }
    }

    // 通过所有检查，更新有效值
    this.lastValidValue = value;
  }

  private revertValue(): void {
    this.el.nativeElement.value = this.lastValidValue;
    // 触发Angular更新
    this.el.nativeElement.dispatchEvent(new Event('input'));
  }

  private formatValue(value: string): void {
    if (!value || value === '-' || value === '.' || value === '-.') return;

    const parts = value.split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1] || '';

    // 处理负号
    const isNegative = integerPart.startsWith('-');
    integerPart = integerPart.replace('-', '') || '0';

    // 处理精度变化
    if (this.precision === 0) {
      this.lastValidValue = isNegative ? `-${integerPart}` : integerPart;
    } else {
      decimalPart = decimalPart.substring(0, this.precision);
      this.lastValidValue = isNegative
        ? `-${integerPart}.${decimalPart}`
        : `${integerPart}.${decimalPart}`;
    }

    this.el.nativeElement.value = this.lastValidValue;
    this.el.nativeElement.dispatchEvent(new Event('input'));
  }
}
